/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_4_TitleInputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_4_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three everyday scenarios, three different decisions`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_4_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`三个日常场景，三种不同选择`)
};

/**
* | output |
* | --- |
* | "Three everyday scenarios, three different decisions" |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_4_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_4_title = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_4_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_4_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_4_title(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_4_title(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_4_title as "gc.search_guides.gridcraft_vs_excel.sections.4.title" }